import { render, staticRenderFns } from "./downShopHouseManage.vue?vue&type=template&id=fdde054e&scoped=true"
import script from "./downShopHouseManage.vue?vue&type=script&lang=js"
export * from "./downShopHouseManage.vue?vue&type=script&lang=js"
import style0 from "./downShopHouseManage.vue?vue&type=style&index=0&id=fdde054e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde054e",
  null
  
)

export default component.exports